// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2EPXb","loadingContainer":"styles_loadingContainer__2ZKMr","title":"styles_title__2sDJf","description":"styles_description__3csEJ"};